module.exports = __webpack_public_path__ + "img/01.cb0ece91.jpg";